import api from './client'

export const importApi = {
  search: (query, maxResults = 20) =>
    api.get('/api/import/search', { params: { query, max_results: maxResults } }),

  importPlaces: (placeIds, query) =>
    api.post('/api/import/google-places', { place_ids: placeIds, query }),

  importCSV: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/api/import/csv', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  verifyCSV: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/api/import/csv/verify', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  importVerified: (rows) =>
    api.post('/api/import/csv/import-verified', { rows }),
}